var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4.21875,
    fill: "#0F86BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.992 5C8.576 5 5 8.584 5 13C5 17.416 8.576 21 12.992 21C17.416 21 21 17.416 21 13C21 8.584 17.416 5 12.992 5ZM13 19.4C9.464 19.4 6.6 16.536 6.6 13C6.6 9.464 9.464 6.6 13 6.6C16.536 6.6 19.4 9.464 19.4 13C19.4 16.536 16.536 19.4 13 19.4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4002 9H12.2002V13.8L16.4002 16.32L17.0002 15.336L13.4002 13.2V9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.96a83f5c6eddde31e4b483264b73988d.svg";
export { ForwardRef as ReactComponent };